new UISearch( document.getElementById( 'sb-search' ) );
$(document).ready(function() {
//	$("table").tablesorter( {
//		sortList: [[0,0]],
//		headers: { 4:{ sorter:false } }
//	} );

	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$('.backTop').fadeIn();
		} else {
			$('.backTop').fadeOut();
		}
	} );

	$('.backTop').on('click', function () {
		$("html, body").animate( {
			scrollTop: 0
		}, 600);
		return false;
	} );

	$('.hamburger').on('click', function(){
		$(this).toggleClass('is-active');
		$('.mainMenu').slideToggle();
	});

	$(".SlideoutActive").toggle(function(){
		$("ul li").each(function(index, element) {
			$(this).animate( {
				"margin-left":index*105
			}	);
			$(this).css("transition","all .5s ease-in-out")
		} );
	}, function() {
		$(".SlideOutMenu ul li").each(function(index, element) {
			$(this).animate( {
				"margin-left":0
			} );
		} );
	} );


	$('.mainMenu > ul > li').on('click', function(){
		$('.mainMenu > ul > li').removeClass('opened');

	});
	$('.mainMenu > ul > li').has('.sub-menu').addClass('hasSubmenu').on('click',function(e) {

		$(this).addClass('opened');

	});

	$(document).on('click', '.filterNavToggle', function (event) {
		event.preventDefault();

		$(this).toggleClass('active');
		$('.filterNavMain').slideToggle(250);
	});

} );
